<div class="teia-modal">
    <div class="td-cnt-ext">
        <div class="td-cnt-md">
            <div class="td-cnt-title">
                <span class="te-title">{{ 'grid.notes' | translate}}</span>
            </div>
            <div class="td-cnt-body">
                <div class="notes">
                    <textarea [(ngModel)]="notes" [readOnly]="readOnly" rows="4" [placeholder]="readOnly ? '' : 'Notes...'"
                        style="flex: 1"></textarea>
                </div>
            </div>
            <div class="td-cnt-btn">
                <teiasoft-button (click)="onCloseClick()" [type]="'tb-cancel'" [text]="'commons.close' | translate"
                    class="mr-5"></teiasoft-button>
                <teiasoft-button *ngIf="!readOnly" (click)="onSaveClick()" [type]="'tb-primary'" [text]="'commons.save' | translate"
                    class="mr-5"></teiasoft-button>
            </div>
        </div>

    </div>
</div>
